export const MarketplaceRole = {
  "beta-user": "Buyer & Developer",
  "beta-buyer": "Buyer",
  "beta-developer": "Developer",
  admin: "Admin",
  REVOKED: "REVOKED"
};

export default MarketplaceRole;
